<template>
    <div id="app" class="d-flex main-wrapper">
        <router-view/>
    </div>
</template>

<script>

export default {
  name: 'App',
  computed: {
  },
  methods: {
  },
};
</script>

<style>

</style>
